import React, {Component, useEffect, useState} from 'react';
import MenuFlutuante from '../../components/MenuFlutuante';
import logoGov from '../../assets/img/logo_govbr.png';
import PopoverComponent from "../popover";


const Header = () => {

    const [auth, setAuth] = useState(null);


    useEffect(() => {
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        setAuth(loggedInUser);
    }, [])

    const isAuthenticated = () => {
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        if (loggedInUser != null) {
            return true;
        }
        return false;
    }

    return (
        <header className="br-header compact" id="header" data-sticky="data-sticky">
            <nav id="skip-links">
                <div className="skip-links">

                </div>
            </nav>

            <div className="container-lg">
                <div className="header-top">
                    <div className="header-logo"><a href="/">
                        <img src={logoGov} alt="logo"/></a><span className="br-divider vertical mx-half mx-sm-1"></span>
                        <div className="header-sign">Ministério da Educação</div>
                    </div>
                    <div className="header-actions">
                        <div className="header-links dropdown">
                            <button className="br-button circle small" type="button" data-toggle="dropdown"
                                    aria-label="Abrir Acesso Rápido"><i className="fas fa-ellipsis-v"
                                                                        aria-hidden="true"></i>
                            </button>
                            <div className="br-list">
                                <div className="header">
                                    <div className="title">Acesso Rápido</div>
                                </div>
                                <a className="br-item" href="https://www.gov.br/mec/pt-br">Ministério da educação</a>
                                <a className="br-item" href="https://www.gov.br/pt-br/orgaos-do-governo">Órgãos do
                                    Governo</a>
                                <a className="br-item" href="https://www.gov.br/acessoainformacao/pt-br">Acesso à
                                    Informação</a>
                                <a className="br-item" href="http://www4.planalto.gov.br/legislacao/">Legislação</a>
                                <a className="br-item"
                                   href="https://www.gov.br/governodigital/pt-br/acessibilidade-digital">Acessibilidade</a>
                            </div>
                        </div>
                        <span className="br-divider vertical mx-half mx-sm-1"></span>
                        <div className="header-functions dropdown">
                            <div className="header-login">
                                <div className="header-sign-in">
                                    {
                                        auth && <PopoverComponent auth={auth}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="header-bottom">
                        <div className="header-menu">
                            <div className="header-menu-trigger">
                                <button className="br-button small circle" type="button" aria-label="Menu"
                                        data-toggle="menu" data-target="#main-navigation" id="navigation">
                                    <i className="fas fa-bars" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div className="header-info">
                                <div className="header-title">Api Gateway Olinda</div>
                                <div className="header-subtitle">Painel Administrativo Interno</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                isAuthenticated() && <MenuFlutuante/>
            }
        </header>

    )

}

export default Header;
